const punctations = [',', '.', '!', '?']
export default class {
    constructor() {
        this.data = null
    }
    parseDOMtoText(dom) {
        const texts = this.flatDomToTextNode(dom)
        return this.createDomStringFromTexts(texts)
    }
    flatDomToTextNode(dom) {
        const textBlocks = [].reduce.call(dom.childNodes, (acc, _) => {
            if (_.tagName) {
                const subDoms = this.flatDomToTextNode(_)
                subDoms.forEach(subDom => {
                    acc.push(subDom)
                })
            } else {
                const word = {
                    caption: _.textContent
                }
                const color = _.parentNode.style.color
                if (_.parentNode.nodeName == 'STRONG' || _.parentNode.parentNode.nodeName == 'STRONG') {
                    word.fontWeigth = 'bold'
                }
                if (color) {
                    word.color = color
                }
                acc.push(word)
            }
            return acc
        }, [])
        return textBlocks
    }
    createDomStringFromTexts(texts) {
        let unsafeHtml = ''
        this.data = texts.map(_ => {
            _.words = _.caption.split(' ')
            return _
        })
        this.data.forEach((text, textIdx) => {
            text.words.forEach((wordStr, wordIdx) => {
                const word = this.makeWord(wordStr, textIdx, wordIdx)
                if (word) {
                    unsafeHtml += `<span class="word"><span class="wrapper"><span class="caption">${word}</span></span></span>`
                }
                unsafeHtml += ' '
            })
        })
        return unsafeHtml
    }
    makeWord(cur, idx, textIdx) {
        if (textIdx === 0 && cur.length === 1 && this.isPunctuation(cur)) {
            return false
        }
        let lastIterationOfBlock = textIdx === this.data[idx].words.length - 1
        let lastBlock = idx === this.data.length - 1

        let blockIdx = lastIterationOfBlock ? idx + 1 : idx
        let nextTextIdx = lastIterationOfBlock ? (lastBlock ? null : 0) : textIdx + 1

        let word = cur/* .split('').map(letter => {
            let style = this.data[idx].color ? ` style="color: ${this.data[idx].color};` : ''
            // console.log(this.data[idx].fontWeigth)
            if (this.data[idx].fontWeigth) {
                style += 'font-weight: bold;';
            }
            style += '"';
            return `<span class="letter"${style}>${letter}</span>`
        }).join("") */
        if (nextTextIdx !== null) {
            if (nextTextIdx === 0) {
                const nextBlock = this.data[blockIdx].words[nextTextIdx]
                if (nextBlock.length === 1 && this.isPunctuation(nextBlock)) {
                    word += `<span class="letter special">${nextBlock}</span>`
                }
            }
        }
        return word
    }
    isPunctuation(cur) {
        return !!punctations.find(_ => _ === cur)
    }

}